export default __webpack_public_path__ + "static/media/audio_33_libelula.366615ae.mp3";